import React from 'react';

import classes from './FeesDeadlines.module.scss';

const FeesDeadlines = () => {
    return <div className={classes.Right}>
        <h1>Fees &amp; Deadlines</h1>
        <p>Thanks to the support  of the Minister of Science and Higher Education grant No. DNK/SP/465255/2020, <span>there is no conference fee.</span></p>
        <p>We would like to ask all participants to follow the conference deadlines:</p>
        <p><span>Registration:</span> February 15, 2021</p>
        <p><span>Abstract submission:</span> February 15, 2021</p>
        <p><span>Proceedings submission:</span> April 30, 2021</p>
    </div >
}

export default FeesDeadlines;